<template>
  <span :id="'hlx-tag-' + unique" ref="hlx-tag" class="hlx-tag">
    <span
      :class="{ content: !limited, contentfull: limited }"
      :style="[limit == true ? 'max-width:10ch' : '']"
    >
      <slot></slot>
    </span>
    <i class="icon-times-regular normal" @click="removeTag"></i>
  </span>
</template>

<script>
export default {
  props: {
    limited: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unique: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
    };
  },
  name: "HlxTag",
  emits: ["tag-close"],
  methods: {
    removeTag($event) {
      let tag = this.$refs["hlx-tag"];
      // let tag = $event.target.parentElement;
      console.log(tag, "taggg");
      if (tag) {
        // tag.remove();
        this.$emit("tag-close", $event);
      }
    },
  },
};
</script>
